import { _ as o } from "./_arrayReduce.js";
import { d as a } from "./deburr.js";
import { w as u } from "./words.js";
var p = o, t = a, d = u, s = "['’]", m = RegExp(s, "g");
function n(r) {
  return function(e) {
    return p(d(t(e).replace(m, "")), r, "");
  };
}
var i = n;
export {
  i as _
};
//# sourceMappingURL=_createCompounder.js.map
